import { GraduationCap } from 'lucide-react';
import { formatTerm } from '@/shared/utils/termUtils';

interface TermSelectProps {
    /** Cuatrimestres a listar, ya ordenados por quien lo usa (D5: más reciente primero). */
    terms: string[];
    value: string | null;
    onChange: (term: string) => void;
    /** Etiqueta visible; por defecto "Cuatrimestre". */
    label?: string;
    disabled?: boolean;
}

/**
 * Desplegable de cuatrimestre reutilizable.
 *
 * Cuando hay un único cuatrimestre (o ninguno) se renderiza **deshabilitado** en vez de
 * ocultarse: sigue siendo informativo —dice qué cursada se está mirando— y evita que la
 * fila del encabezado cambie de altura al pasar de uno a varios cuatrimestres.
 */
export default function TermSelect({
    terms,
    value,
    onChange,
    label = 'Cuatrimestre',
    disabled = false,
}: TermSelectProps) {
    const isDisabled = disabled || terms.length <= 1;

    return (
        <label className="inline-flex items-center gap-2 text-sm text-gray-600 whitespace-nowrap">
            <GraduationCap className="w-4 h-4 text-gray-400" />
            <span className="font-medium">{label}:</span>
            <select
                value={value ?? ''}
                onChange={(e) => onChange(e.target.value)}
                disabled={isDisabled}
                className="text-sm border border-gray-300 rounded-lg px-2 py-1.5 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
            >
                {value === null && <option value="">—</option>}
                {terms.map((term) => (
                    <option key={term} value={term}>
                        {formatTerm(term)}
                    </option>
                ))}
            </select>
        </label>
    );
}
